// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface MessengerIconSignature {
  Element: SVGSVGElement;
}

export const MessengerIcon: TOC<MessengerIconSignature> = <template><svg width="24" height="25" viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M0 12.1111C0 5.97459 5.33941 1 11.9259 1C18.5124 1 23.8519 5.97459 23.8519 12.1111C23.8519 18.2476 18.5124 23.2222 11.9259 23.2222C10.7369 23.2222 9.58881 23.0593 8.50511 22.7576L4.44444 25V20.7635C1.73422 18.7267 0 15.6078 0 12.1111ZM10.0741 12.7037L13.1111 15.963L19.6296 9L13.7778 12.2593L10.6667 9L4.14815 15.963L10.0741 12.7037Z"/>
</svg>
</template>;